import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';

// ---- F8 supplier bill requests (staff inbox) ----
export type BillRequestStatus = 'SUBMITTED' | 'UNDER_REVIEW' | 'CONVERTED' | 'REJECTED' | 'WITHDRAWN';

export interface BillRequest {
  id: string; requestNo: string; supplierId: string; supplierName?: string | null;
  purchaseOrderId?: string | null; poNumber?: string | null; supplierInvoiceNo: string; invoiceDate: string;
  amount: number; description?: string | null; hasFile: boolean; contentType?: string | null; sizeBytes?: number | null;
  status: BillRequestStatus; reviewComment?: string | null; reviewedBy?: string | null; reviewedAt?: string | null;
  supplierBillId?: string | null; submittedByContactId: string; submittedByName?: string | null; submittedAt?: string | null;
}
export interface BillRequestPage { rows: BillRequest[]; total: number; page: number; size: number; }

export interface PoBillLine { goodsReceiptLineId: string; quantity: number; unitPrice: number; taxCodeId?: string | null; }
export interface ServiceBillLine { accountId: string; segmentId?: string | null; description?: string; amount: number; taxCodeId?: string | null; }
export interface ConvertRequest {
  poBill?: {
    purchaseOrderId: string; supplierInvoiceRef: string; billDate: string; dueDate?: string | null; taxAmount?: number;
    institutionId: string; lines: PoBillLine[];
  } | null;
  serviceBill?: {
    institutionId: string; supplierId: string; supplierInvoiceRef: string; billDate: string; dueDate?: string | null;
    lines: ServiceBillLine[]; currencyCode?: string | null; exchangeRate?: number | null;
  } | null;
}
export interface ConvertResult {
  request: BillRequest; supplierBillId: string; billNumber?: string | null; billStatus?: string | null;
  approvalStatus?: string | null; approvalRequestId?: string | null; onApprovalHold: boolean;
}
export interface PoAck {
  purchaseOrderId: string; acknowledged: boolean; acknowledgedAt?: string | null; contactId?: string | null;
  contactName?: string | null; contactEmail?: string | null; note?: string | null;
}

const E = ENDPOINTS.SUPPLIER_BILL_REQUEST;

export const SupplierBillRequestService = {
  list: async (i: string, f: { status?: string; supplierId?: string }, page = 0, size = 50): Promise<BillRequestPage> =>
    (await axios.get(E.LIST(i), { params: { ...Object.fromEntries(Object.entries(f).filter(([, v]) => v)), page, size } })).data,
  get: async (i: string, id: string): Promise<BillRequest> => (await axios.get(E.ONE(i, id))).data,
  file: async (i: string, id: string): Promise<Blob> => (await axios.get(E.FILE(i, id), { responseType: 'blob' })).data,
  comment: async (i: string, id: string, comment: string): Promise<BillRequest> => (await axios.post(E.COMMENT(i, id), { comment })).data,
  reject: async (i: string, id: string, comment: string): Promise<BillRequest> => (await axios.post(E.REJECT(i, id), { comment })).data,
  convert: async (i: string, id: string, req: ConvertRequest): Promise<ConvertResult> => (await axios.post(E.CONVERT(i, id), req)).data,
  coveredGrnLines: async (i: string, id: string): Promise<string[]> => (await axios.get(E.COVERED_GRN_LINES(i, id))).data,
  poAck: async (i: string, poId: string): Promise<PoAck> => (await axios.get(E.PO_ACK(i, poId))).data,
};
// ---- end F8 ----
